"use client";

const COOKIE_NAME = "convex-session";
const NEW_USER_COOKIE = "is_new_user";
const MAX_AGE_DAYS = 30;

export function setSessionCookie(token: string) {
  const secure = typeof location !== "undefined" && location.protocol === "https:";
  const maxAge = MAX_AGE_DAYS * 24 * 60 * 60;
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(token)}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure ? "; Secure" : ""}`;
}

export function setNewUserFlag() {
  const secure = typeof location !== "undefined" && location.protocol === "https:";
  document.cookie = `${NEW_USER_COOKIE}=1; Path=/; Max-Age=60; SameSite=Lax${secure ? "; Secure" : ""}`;
}

export function readUtmArgs() {
  if (typeof document === "undefined") return {} as Record<string, string | undefined>;
  const match = document.cookie.match(/(?:^|; )UTM_DATA=([^;]*)/);
  if (!match) return {};
  try {
    const raw = JSON.parse(decodeURIComponent(match[1])) as Record<string, string>;
    return {
      utmSource: raw.utm_source,
      utmMedium: raw.utm_medium,
      utmCampaign: raw.utm_campaign,
      utmContent: raw.utm_content,
      utmTerm: raw.utm_term,
    };
  } catch {
    return {};
  }
}
